import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="header">
      <div className="header-container">
        {/* Logo and Brand */}
        <div className="brand">
          <img 
            src="/img/MS_logo.png" 
            alt="MS Group Constructora" 
            className="logo-img" 
          />
          <div className="brand-text">
            <h1>
              <span className="ms">MS</span> GROUP
            </h1>
            <span className="constructora">CONSTRUCTORA</span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="nav">
          <ul className="nav-links">
            <li><a href="#home">Inicio</a></li>
            <li><a href="#about">Nosotros</a></li>
            <li><a href="#services">Servicios</a></li>
            <li><a href="#contact">Contacto</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;